const carouselItems = [
  {
    title: '2026 夏季舞蹈大赛特辑',
    desc: '聚焦今夏最火爆的舞蹈赛事，从街舞到现代舞，每日大赛作品介绍为你精选不容错过的精彩对决，感受舞者们的燃情时刻。',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20warm%20artistic%20composition%20representing%20dance%20and%20movement%2C%20flowing%20fabric%20and%20light%20trails%20in%20coral%20and%20amber%20tones%2C%20elegant%20modern%20design%2C%20soft%20gradients%2C%20sophisticated%20atmosphere%2C%20editorial%20style%2C%20no%20text%2C%20no%20people&width=900&height=500&seq=carousel-daily-01&orientation=landscape',
    tag: '夏季特辑',
  },
  {
    title: '原创音乐人创作大赛回顾',
    desc: '年度最具影响力的音乐创作赛事回顾，从词曲到演唱，每日大赛类型中的音乐赛道持续产出高质量原创作品。',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20abstract%20musical%20composition%20with%20flowing%20golden%20sound%20waves%2C%20warm%20coral%20accents%2C%20soft%20atmospheric%20lighting%2C%20artistic%20minimalist%20style%2C%20sophisticated%20editorial%20quality%2C%20no%20text%2C%20no%20people&width=900&height=500&seq=carousel-daily-02&orientation=landscape',
    tag: '音乐专题',
  },
  {
    title: 'AI 创意大赛前沿观察',
    desc: '人工智能与创意碰撞的前沿赛场，每日大全为你整理最具创新力的AI艺术、AI音乐等新兴大赛赛道和获奖作品。',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20futuristic%20composition%20with%20geometric%20patterns%20and%20warm%20amber%20light%2C%20flowing%20digital%20textures%2C%20soft%20coral%20highlights%2C%20modern%20minimalist%20design%2C%20elegant%20atmosphere%2C%20editorial%20style%2C%20no%20text%2C%20no%20people&width=900&height=500&seq=carousel-daily-03&orientation=landscape',
    tag: '前沿观察',
  },
  {
    title: '短视频创作大赛热门趋势',
    desc: '短视频赛道持续升温，每日大赛入口追踪最新热门大赛视频动态，解读短视频创作大赛的爆款密码和趋势方向。',
    image: 'https://readdy.ai/api/search-image?query=Dynamic%20abstract%20composition%20with%20flowing%20light%20streaks%20and%20soft%20gradients%20in%20warm%20coral%20and%20gold%20tones%2C%20modern%20minimalist%20design%2C%20elegant%20movement%20suggestion%2C%20editorial%20photography%20style%2C%20no%20text%2C%20no%20people&width=900&height=500&seq=carousel-daily-04&orientation=landscape',
    tag: '热门趋势',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading text-center mb-3">
          焦点专题
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          每日大赛入口精选专题，深度解读热门大赛赛道
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {carouselItems.map((item) => (
            <div
              key={item.title}
              className="group rounded-xl overflow-hidden border border-background-200/70 bg-background-50 cursor-pointer transition-all duration-300 hover:-translate-y-1"
            >
              <div className="relative w-full h-44 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute top-3 left-3">
                  <span className="inline-block px-2.5 py-1 rounded-full text-xs font-medium bg-primary-500 text-white">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-900 mb-1.5">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-3">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}